/* eslint-disable react/prop-types */
import React from 'react';

export function ProductGroupFooter(props) {
  return (
    <div className="summarypage-bifreshtime">
      {props.i18n.getString('BITimeStampNotes_Label')}
      <button className="HelpTopic btn-link learn-more" query="help:ext54480">
        {props.i18n.getString('LearnMoreLinkText')}
      </button>
      <br />
      {props.i18n.getString('MRCAccredited_Label')}
      <button className="DelegateLink btn-link learn-more" onClick={() => window.open('https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-click-measurement-description-of-methodology')}>
        {props.i18n.getString('LearnMoreLinkText')}
      </button>
      {props.i18n.getString('MRCAccredited_Label')}
      {props.accountTimeZoneText}
      <button className="HelpTopic btn-link learn-more" query="help:ext54483">
        {props.i18n.getString('LearnMoreLinkText')}
      </button>
      <br />
    </div>
  );
}
